import AScene from '../../library/ExtendedObjects/AScene.js';
import gameData from '../../gameData.js';
import Tile from '../tiles/tile.js';
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';
import UIAssetKeys from '../../UIAssetKeys.js';

export default class Intro extends AScene {
  static get KEY() { return 'Intro';}

  create() {
    gameData.currentScene = 'Intro';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.level = 1;
    gameData.gameMode = 'all';
    gameData.placementCounter = 0;
    gameData.tries = 0;

    this.bg = this.addImage(this.mid.x, this.mid.y, 'Clsc_BG');

    this.createTiles();
    this.createSelect();
    this.tweenInTiles();
  }

  createTiles() {
    if(ABCyaLib.Environment.instance.locale === 'es-US'){
      this.esBG = this.addImage(this.mid.x, this.mid.y, 'TitleTray2', ABCyaPhaser.Images.LOCALIZATION_ATLAS);

      this.tSpot7 = this.addImage(this.mid.x - this.mid.x / 2 - 53, 880, UIAssetKeys._tileBgSmall);
      this.tSpot8 = this.addImage(this.mid.x, 880, UIAssetKeys._tileBgSmall);
      this.tSpot9 = this.addImage(this.mid.x + this.mid.x / 2 + 53, 880, UIAssetKeys._tileBgSmall);

      this.t1 = this.addImage(-700, 295, 'Btn_rompecabezas', ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.t2 = this.addImage(1200, 475, 'Btn_deslizante', ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.t3 = this.addImage(-700, 656, 'Btn_deletras', ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.t4 = this.addButton(-133, 1075, UIAssetKeys._LtrCase_A, {}, () => {this.setCase(this.t4);});
      this.t4.setScale(1.25, 1.25);
      this.t4.setEnabled(false);
      this.t5 = this.addButton(1150, 1075, UIAssetKeys._LtrCase_LwrA, {}, () => {this.setCase(this.t5);});
      this.t5.setScale(1.25, 1.25);
      this.t5.setEnabled(false);
  
      this.t6 = this.add.container(this.tSpot8.x, this.tSpot8.y);
      const t8bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LtrCase, this.t6);
      const letterTxt = ABCyaPhaser.Text.addText(0,-55,42, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.letter_case_label.letter"), this.t6, true);
      const caseTxt = ABCyaPhaser.Text.addText(0,-10,58, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.letter_case_label.case"), this.t6, true);
      ABCyaPhaser.Text.resizeFontToFitWidth(letterTxt, 160,null, 42);
      ABCyaPhaser.Text.resizeFontToFitWidth(caseTxt, 160,null, 58);
      this.t6.setAlpha(0);
  
      this.a1 = this.addImage(this.tSpot8.x - 50, this.tSpot8.y + 50, UIAssetKeys._Title_ArrowL);
      this.a2 = this.addImage(this.tSpot8.x + 50, this.tSpot8.y + 50, UIAssetKeys._Title_ArrowR);
      this.a1.setAlpha(0);
      this.a2.setAlpha(0);
  
      this.tSpots = [this.tSpot7, this.tSpot8, this.tSpot9];
      this.titleTiles = [this.t1, this.t2, this.t3, this.t4, this.t5, this.t6, this.a1, this.a2];
    } else {
      this.tSpot1 = this.addImage(this.mid.x - this.mid.x / 2 - 30, 150, UIAssetKeys._tileBgSmall);
      this.tSpot2 = this.addImage(this.mid.x, 150, UIAssetKeys._tileBgSmall);
      this.tSpot3 = this.addImage(this.mid.x + this.mid.x / 2 + 30, 150, UIAssetKeys._tileBgSmall);
  
      this.tSpot4 = this.addImage(this.mid.x, 375, UIAssetKeys._tileBgLarge);
      this.tSpot5 = this.addImage(this.mid.x, 600, UIAssetKeys._tileBgLarge);
  
      this.tSpot6 = this.addImage(this.mid.x - this.mid.x / 2 - 30, 875, UIAssetKeys._tileBgSmall);
      this.tSpot7 = this.addImage(this.mid.x, 875, UIAssetKeys._tileBgSmall);
      this.tSpot8 = this.addImage(this.mid.x + this.mid.x / 2 + 30, 875, UIAssetKeys._tileBgSmall);

      this.t1 = this.addImage(-125, -125, UIAssetKeys._Title_A_1);
      this.t1.setScale(1.25, 1.25);
      this.t2 = this.addImage(this.tSpot2.x, -125, UIAssetKeys._Title_B_1);
      this.t2.setScale(1.25, 1.25);
      this.t3 = this.addImage(1150, -125, UIAssetKeys._Title_C_1);
      this.t3.setScale(1.25, 1.25);
  
      this.t4 = this.add.container(-700, this.tSpot4.y);
      const t4bg = ABCyaPhaser.Images.addImage(0, 0,UIAssetKeys._Title_Slider_1, this.t4);
      const t4txt = ABCyaPhaser.Text.addText(0, 0, 152, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.title.slider"), this.t4, true);
      ABCyaPhaser.Text.resizeFontToFitWidth(t4txt, t4bg.getBounds().width - 40);
      this.t4.setScale(1.25, 1.25);
  
      this.t5 = this.add.container(1724, this.tSpot5.y);
      const t5bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Title_Puzzle_1, this.t5);
      const t5txt = ABCyaPhaser.Text.addText(0,0,152, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.title.puzzle"), this.t5, true);
      ABCyaPhaser.Text.resizeFontToFitWidth(t5txt, t5bg.getBounds().width - 40);
      this.t5.setScale(1.25, 1.25);
  
      this.t6 = this.addButton(-133, 1075, UIAssetKeys._LtrCase_A, {}, () => {this.setCase(this.t6);});
      this.t6.setScale(1.25, 1.25);
      this.t6.setEnabled(false);
      this.t7 = this.addButton(1150, 1075, UIAssetKeys._LtrCase_LwrA, {}, () => {this.setCase(this.t7);});
      this.t7.setScale(1.25, 1.25);
      this.t7.setEnabled(false);
  
      this.t8 = this.add.container(this.tSpot7.x, this.tSpot7.y);
      const t8bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LtrCase, this.t8);
      const letterTxt = ABCyaPhaser.Text.addText(0,-55,42, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.letter_case_label.letter"), this.t8, true);
      const caseTxt = ABCyaPhaser.Text.addText(0,-10,58, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.letter_case_label.case"), this.t8, true);
      ABCyaPhaser.Text.resizeFontToFitWidth(letterTxt, 160,null, 42);
      ABCyaPhaser.Text.resizeFontToFitWidth(caseTxt, 160,null, 58);
      this.t8.setAlpha(0);
  
      this.a1 = this.addImage(this.tSpot7.x - 50, this.tSpot7.y + 50, UIAssetKeys._Title_ArrowL);
      this.a2 = this.addImage(this.tSpot7.x + 50, this.tSpot7.y + 50, UIAssetKeys._Title_ArrowR);
      this.a1.setAlpha(0);
      this.a2.setAlpha(0);
  
      this.tSpots = [this.tSpot1, this.tSpot2, this.tSpot3, this.tSpot4, this.tSpot5, this.tSpot6, this.tSpot7, this.tSpot8];
      this.titleTiles = [this.t1, this.t2, this.t3, this.t4, this.t5, this.t6, this.t7, this.t8, this.a1, this.a2];
    }
  }

  tweenInTiles() {
    this.addDelay(300, () => {this.playSound('intro_tween');});

    if(ABCyaLib.Environment.instance.locale === 'es-US'){
      this.addTween(
        this.t1,
        750,
        { x: this.mid.x, delay: 250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t1, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t2,
        750,
        { x: this.mid.x, delay: 500 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t2, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t3,
        750,
        { x: this.mid.x, delay: 750 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t3, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );

      this.addTween(
        this.t4,
        750,
        { x: this.tSpot7.x + 3, y: this.tSpot7.y + 3, delay: 1250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t4, 750, { scaleX: .9, scaleY: .9, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t5,
        750,
        { x: this.tSpot9.x + 3, y: this.tSpot9.y + 3, delay: 1250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {
          this.addTween(this.t5, 750, { scaleX: .9, scaleY: .9, delay: 200 }, Phaser.Math.Easing.Bounce.Out);
          this.addTween(this.t6, 750, { alpha: 1 }, Phaser.Math.Easing.Linear);
          this.addTween(this.a1, 750, { alpha: 1 }, Phaser.Math.Easing.Linear);
          this.addTween(
            this.a2,
            750,
            { alpha: 1 },
            Phaser.Math.Easing.Linear,
            () => {
              this.t4.setEnabled(true);
              this.t5.setEnabled(true);
              this.addTween(this.a1, 1500, { scaleX: 1.25, scaleY: 1.25, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.t4, 1500, { scaleX: 1, scaleY: 1, yoyo: true, repeat: -1, delay: 2000, repeatDelay: 2000 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.a2, 1500, { scaleX: 1.25, scaleY: 1.25, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.t5, 1500, { scaleX: 1, scaleY: 1, yoyo: true, repeat: -1, delay: 2000, repeatDelay: 2000 }, Phaser.Math.Easing.Quadratic.InOut);
            }
          );
        }
      );
    } else {
      this.addTween(
        this.t1,
        750,
        { x: this.tSpot1.x, y: this.tSpot1.y },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t1, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t2,
        750,
        { y: this.tSpot2.y, delay: 250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t2, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t3,
        750,
        { x: this.tSpot3.x, y: this.tSpot3.y, delay: 500 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t3, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
  
      this.addTween(
        this.t4,
        750,
        { x: this.tSpot4.x, delay: 750 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t4, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t5,
        750,
        { x: this.tSpot5.x, delay: 1000 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t5, 750, { scaleX: 1, scaleY: 1, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
  
      this.addTween(
        this.t6,
        750,
        { x: this.tSpot6.x + 3, y: this.tSpot6.y + 3, delay: 1250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {this.addTween(this.t6, 750, { scaleX: .9, scaleY: .9, delay: 200 }, Phaser.Math.Easing.Bounce.Out);}
      );
      this.addTween(
        this.t7,
        750,
        { x: this.tSpot8.x + 3, y: this.tSpot8.y + 3, delay: 1250 },
        Phaser.Math.Easing.Quadratic.Out,
        () => {
          this.addTween(this.t7, 750, { scaleX: .9, scaleY: .9, delay: 200 }, Phaser.Math.Easing.Bounce.Out);
          this.addTween(this.t8, 750, { alpha: 1 }, Phaser.Math.Easing.Linear);
          this.addTween(this.a1, 750, { alpha: 1 }, Phaser.Math.Easing.Linear);
          this.addTween(
            this.a2,
            750,
            { alpha: 1 },
            Phaser.Math.Easing.Linear,
            () => {
              this.t6.setEnabled(true);
              this.t7.setEnabled(true);
              this.addTween(this.a1, 1500, { scaleX: 1.25, scaleY: 1.25, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.t6, 1500, { scaleX: 1, scaleY: 1, yoyo: true, repeat: -1, delay: 2000, repeatDelay: 2000 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.a2, 1500, { scaleX: 1.25, scaleY: 1.25, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
              this.addTween(this.t7, 1500, { scaleX: 1, scaleY: 1, yoyo: true, repeat: -1, delay: 2000, repeatDelay: 2000 }, Phaser.Math.Easing.Quadratic.InOut);
            }
          );
        }
      );
    }
  }

  setCase(btn) {
    this.playSound('click');

    if(ABCyaLib.Environment.instance.locale === 'es-US'){
      this.t4.setEnabled(false);
      this.t5.setEnabled(false);
    } else {
      this.t6.setEnabled(false);
      this.t7.setEnabled(false);
    }

    if (btn.frame.name === 'LtrCase_A') {
      gameData.gameMode = 'upper';
    }
    else {
      gameData.gameMode = 'lower';
    }

    this.tweenOutTitle();
  }

  swapMode(btn) {
    // console.log(btn.frame.name);
    this.playSound('click');

    this.arrowR.setEnabled(false);
    this.arrowL.setEnabled(false);

    if (btn.frame.name === 'Title_ArrowL') {
      gameData.gameMode = 'lower';

      this.addTween(this.arrowL, 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
    }
    else {
      gameData.gameMode = 'upper';

      this.addTween(this.arrowR, 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
    }

    this.tweenOutSelect();
  }

  tweenOutTitle() {
    // console.log("tweening out");
    for (let i = 0; i < this.tSpots.length; i++) {
      this.addTween(this.tSpots[i], 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0, delay: 100 * i }, Phaser.Math.Easing.Linear);
    }
    for (let i = 0; i < this.titleTiles.length; i++) {
      this.addTween(this.titleTiles[i], 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0, delay: 100 * i }, Phaser.Math.Easing.Linear);
    }

    if(this.esBG)this.addTween (this.esBG, 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);

    this.tweenInSelect();
  }

  tweenInSelect(isReset) {
    // console.log("tweening in select", gameData.gameMode);
    if (gameData.gameMode === 'upper') {
      this.txt.text = ABCyaPhaser.Localization.instance.getLocalizedString("type_select_screen.header.uppercase");

      for (let i = 0; i < this.tiles.length; i++) {
        this.tiles[i].setLetter('A');
      }
    }
    else {
      this.txt.text = ABCyaPhaser.Localization.instance.getLocalizedString("type_select_screen.header.lowercase");

      for (let i = 0; i < this.tiles.length; i++) {
        this.tiles[i].setLetter('a');
      }
    }

    if (isReset) {
      if (gameData.gameMode === 'upper') {
        this.addTween(
          this.arrowL,
          500,
          { scaleX: 1, scaleY: 1, alpha: 1, delay: 1300 },
          Phaser.Math.Easing.Back.Out,
          () => {this.arrowL.setEnabled(true);}
        );
      }
      else {
        this.addTween(
          this.arrowR,
          500,
          { scaleX: 1, scaleY: 1, alpha: 1, delay: 1300 },
          Phaser.Math.Easing.Back.Out,
          () => {this.arrowR.setEnabled(true);}
        );
      }

      this.addTween(this.txt, 1000, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Back.Out);

      for (let i = 0; i < this.tiles.length; i++) {
        this.addDelay(400 + (100 * i), () => {this.playSound('themes_tween');});
        this.addTween(this.tiles[i], 1000, { scaleX: 1, scaleY: 1, alpha: 1, delay: 100 * i }, Phaser.Math.Easing.Bounce.Out);
      }
    }
    else {
      this.addTween(this.txt, 1000, { scaleX: 1, scaleY: 1, delay: 350 }, Phaser.Math.Easing.Back.Out);

      if (gameData.gameMode === 'upper') {
        this.addTween(
          this.arrowL,
          500,
          { scaleX: 1, scaleY: 1, alpha: 1, delay: 1300 },
          Phaser.Math.Easing.Back.Out,
          () => {this.arrowL.setEnabled(true);}
        );
      }
      else {
        this.addTween(
          this.arrowR,
          500,
          { scaleX: 1, scaleY: 1, alpha: 1, delay: 1300 },
          Phaser.Math.Easing.Back.Out,
          () => {this.arrowR.setEnabled(true);}
        );
      }

      for (let i = 0; i < this.tiles.length; i++) {
        this.addDelay(850 + (100 * i), () => {this.playSound('themes_tween');});
        this.addTween(this.tiles[i], 1000, { scaleX: 1, scaleY: 1, alpha: 1, delay: 450 + (100 * i) }, Phaser.Math.Easing.Bounce.Out);
      }
    }
  }

  tweenOutSelect(isEnd) {
    // console.log("tweening Out select");
    this.playSound('theme_exit');

    if (isEnd) {
      this.arrowR.setEnabled(false);
      this.arrowL.setEnabled(false);

      this.addTween(
        this.txt,
        505,
        { scaleX: 1.25, scaleY: 1.25, alpha: 0 },
        Phaser.Math.Easing.Linear,
        () => {this.cleanUp();}
      );

      this.addTween(this.arrowL, 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
      this.addTween(this.arrowR, 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);

      for (let i = 0; i < this.tiles.length; i++) {
        this.addTween(this.tiles[i], 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
      }
    }
    else {
      this.addTween(
        this.txt,
        500,
        { scaleX: 1.25, scaleY: 1.25, alpha: 0 },
        Phaser.Math.Easing.Linear,
        () => {this.tweenInSelect(true);}
      );

      for (let i = 0; i < this.tiles.length; i++) {
        this.addTween(this.tiles[i], 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
      }
    }
  }

  createSelect() {
    // console.log("tweening out");
    this.tileBgs = ['Clsc', 'Camo', 'Neon', 'Spc', 'Uncrn', 'Wood', 'Sprng', 'Smr', 'Atm', 'Wntr'];
    this.tiles = [];

    for (let i = 0; i < this.tileBgs.length; i++) {
      const btn = new Tile(this, this.tileBgs[i], true);
      this.addToParent(btn, this);

      if (i === 0 || i === 2 || i === 4 || i === 6 || i === 8) {
        btn.setPosition(200, 235 + (85 * i));
      }
      else {
        btn.setPosition(570, 150 + (85 * i));
      }

      this.tiles.push(btn);
    }

    if (gameData.gameMode = 'upper') {
      this.txt = this.addText(this.mid.x, 100, 65, 0xFFFFFF, FontKeys._Quicksand, 'UPPERCASE', this, true);
    }
    else {
      this.txt = this.addText(this.mid.x, 100, 65, 0xFFFFFF, FontKeys._Quicksand, 'LOWERCASE', this, true);
    }
    this.txt.setScale(0, 0);

    this.arrowR = this.addButton(668, this.txt.y, 'Title_ArrowR', {}, () => {this.swapMode(this.arrowR);});
    this.arrowL = this.addButton(100, this.txt.y, 'Title_ArrowL', {}, () => {this.swapMode(this.arrowL);});
    this.arrowR.setEnabled(false);
    this.arrowL.setEnabled(false);
    this.arrowR.setScale(0, 0);
    this.arrowL.setScale(0, 0);

    for (let i = 0; i < this.tiles.length; i++) {
      this.tiles[i].setScale(1.25, 1.25);
      this.tiles[i].setAlpha(0);
    }
  }

  endIntro() {
    // console.log("intro ending", gameData.gameStyle, gameData.gameMode);
    for (let i = 0; i < this.tiles.length; i++) {
      this.tiles[i].title.setEnabled(false);
    }

    this.tweenOutSelect(true);
  }

  cleanUp() {
    // console.log('going to game');

    for (let i = 0; i < this.tiles.length; i++) {
      this.tiles[i].destroy();
    }
    for (let i = 0; i < this.tSpots.length; i++) {
      this.tSpots[i].destroy();
    }
    for (let i = 0; i < this.titleTiles.length; i++) {
      this.titleTiles[i].destroy();
    }

    this.arrowL.destroy();
    this.arrowR.destroy();
    this.txt.destroy();

    this.bg.destroy();

    this.scene.start('Game');
  }
}